import './index.scss'
$("#nav3").addClass("active");
$(".product-list .ul li").click(function () {
    let index = $(this).index();
    $(".product-list .ul").addClass("hide");
    $(".pages").addClass("hide");
    $(".product-pop .product-content").eq(index).addClass("active").siblings().removeClass("active");
    var top = $(".product").offset().top;
    $('html,body').animate({
        scrollTop: top - 200
    }, 500);
})
$(".back").click(function () {
    $(".product-list .ul").removeClass("hide");
    $(".pages").removeClass("hide");
    $(".product-pop .product-content").removeClass("active");
    var top = $(".product").offset().top;
    $('html,body').animate({
        scrollTop: top - 200
    }, 500);
})